<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockThisUI">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h3>Get Studies By Date Range</h3>
    <!--<button (click)="closeModal()">Close</button>-->
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <form (ngSubmit)="generateReport()" class="date-form">
          <div class="form-row">
            <div class="form-group">
              <label for="fromDate">From Date:</label>
              <input type="date" id="fromDate" [(ngModel)]="fromDate" name="fromDate" required />
            </div>
            <div class="form-group">
              <label for="toDate">To Date:</label>
              <input type="date" id="toDate" [(ngModel)]="toDate" name="toDate" required />
            </div>
            <div class="form-group">
              <div class="switch-container-study-setup">
                <label class="ai-enabled custom-control-label form-check-label">Gen AI Studies</label>
                <p-inputSwitch name="studyScopeSwitch"
                               [(ngModel)]="isLegacyStudy"
                               [disabled]="false"
                               aria-label="Toggle between Gen AI Studies and Non Gen AI Studies"
                               appPCheckbox
                               ></p-inputSwitch>
                <label class="ai-disabled custom-control-label form-check-label">Non Gen AI Studies</label>
              </div>
            </div>
            </div>
          <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </div>
    <!--<div *ngIf="showGeneralInfo">-->
    <div class="row columns-heading">
      <div class="col-12">General Information</div>
    </div>
    <div class="row disclaimer">
      <div class="col-12">* Note: This data will always be generated *</div>
    </div>
    <div class="row" *ngIf="defaultColumns.length > 0">
      <div class="col-12">
        <div class="default-columns">
          <div class="default-column" *ngFor="let column of defaultColumns"><i class="material-icons check-icon">done</i>{{ column }}</div>
        </div>
      </div>
    </div>
    <!--<div *ngIf="isSelectionAvailable()">-->
    <div style="display: none" class="row columns-heading">
      <div class="col-12">Optional Columns</div>
    </div>
    <div style="display: none" class="row">
      <div class="col-12 disclaimer">Note: Drag the column name to the right that you would like to include in your report</div>
    </div>
    <!--<div class="row">
        <div class="col-12">
          <form (click)="generateReport()" class="date-form">
            <div class="form-row">
              <div class="form-group">
                <label for="fromDate">From Date:</label>
                <input type="date" id="fromDate" [(ngModel)]="fromDate" name="fromDate" required />
              </div>
              <div class="form-group">
                <label for="toDate">To Date:</label>
                <input type="date" id="toDate" [(ngModel)]="toDate" name="toDate" required />
              </div>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary">Generate Excel</button>
            </div>
          </form>
        </div>
      </div>-->
    <div style="display: none" class="row">
      <div class="col-12">
        <p-pickList
          [source]="sourceColumns"
          [target]="selectedColumns"
          [dragdrop]="true"
          [responsive]="true"
          styleClass="reports-optional-col-selector"
          [showSourceControls]="false"
          [showTargetControls]="false"
          (onMoveToTarget)="updateSelectedColumns($event)"
        >
          <ng-template pTemplate="emptymessagetarget"> DRAG HERE </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="export-option-card">
              <div class="d-table">
                <div class="d-table-cell">
                  <i class="material-icons drag-icon">more_vert</i>
                </div>
                <div class="d=table-cell">
                  {{ option.label }}
                </div>
              </div>
            </div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
    <!--</div>-->
    <!--</div>-->
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" (click)="cancelModal()">Cancel</button>
    <button class="btn btn-default" (click)="generateReport()">Generate</button>
  </div>
</div>
